
import { Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import Aos from "aos";
import React, { useEffect } from "react";

const LaboratoriosFarmaceuticos = React.forwardRef((props, ref: React.Ref<HTMLDivElement>) => {
    useEffect(() => {
        Aos.init({ duration: 500 })
    }, [])
    const theme = useTheme();
    const isSmall = !useMediaQuery(theme.breakpoints.up('lg'))
    const [indexState, setIndexState] = React.useState(0);

    var afiliateArray = [0, 1, 2, 3, 4, 5, 6, 7];
    return <div
        ref={ref}
        className='BackgroundTile' style={{
            textAlign: "left", padding: "1rem", color: "white",
            display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", minHeight: "100vh"
        }} >
        <Typography variant='h4' style={{ fontWeight: 600, textAlign: "center" }} data-aos='zoom-in'>
            Laboratorios farmacéuticos
        </Typography>
        <div data-aos="fade-up">
            <div style={{ display: "flex", flexDirection: isSmall ? "column" : "row", marginTop: "1rem" }} data-aos={'fade-right'}>
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", minWidth: isSmall ? "70%" : "auto" }}>
                    {
                        afiliateArray.map((v, i) =>
                            <div onClick={() => { setIndexState(i); }}>
                                <Paper className='Partners'
                                    elevation={8} style={{
                                        margin: ".2rem",
                                        border: "solid 1px #96cbfa",
                                        height: "max-content",
                                        background: "linear-gradient(rgba(13, 29, 69, 0.6) 0%, rgba(99, 91, 255, 0) 92.07%)",
                                        backgroundColor: "white",
                                        marginTop: (i % 2 == 0) ? "1rem" : "0"
                                    }} data-aos='fade-up' data-aos-delay={50 + 100 * i}>

                                    <div style={{ margin: "1rem" }} >
                                        <img
                                            // eslint-disable-next-line eqeqeq
                                            style={{ marginTop: (i % 2 == 0) ? "1rem" : "0" }}
                                            src={`a${i + 1}.svg`} width={isSmall ? 50 : 100} height={isSmall ? 50 : 100} alt="" /></div>
                                </Paper>
                            </div>
                        )
                    }

                </div>
            </div>
        </div>
    </div>
})

export {LaboratoriosFarmaceuticos}